module.exports = __webpack_public_path__ + "static/media/Middle_First_Building_Light.02054ed5.png";